import { render, staticRenderFns } from "./NptTable.vue?vue&type=template&id=0ee029e0&scoped=true"
import script from "./NptTable.vue?vue&type=script&lang=ts"
export * from "./NptTable.vue?vue&type=script&lang=ts"
import style0 from "./NptTable.vue?vue&type=style&index=0&id=0ee029e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee029e0",
  null
  
)

export default component.exports